import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../lib/api";
import DeathProcess from "../components/DeathProcess";
import { BookHeart, Lock } from "lucide-react";

const ComunicaScomparsa = () => {
  const { token } = useParams();
  const [data, setData] = useState(undefined);

  const load = () => api.get(`/death-report/${token}`).then((r) => setData(r.data)).catch(() => setData(null));
  useEffect(() => { load(); }, [token]);

  if (data === undefined)
    return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Caricamento…</div>;
  if (data === null)
    return (
      <div className="min-h-screen flex items-center justify-center px-6">
        <div className="text-center bg-white rounded-3xl border border-border p-12 max-w-md" data-testid="comunica-invalid">
          <Lock className="w-10 h-10 text-muted-foreground mx-auto mb-4" />
          <h1 className="font-serif text-2xl mb-2">Link non valido</h1>
          <p className="text-muted-foreground">Questo link non è più valido o non esiste.</p>
        </div>
      </div>
    );

  return (
    <div className="min-h-screen">
      <header className="border-b border-border bg-[#F9F6F0]/85 backdrop-blur-md">
        <div className="max-w-3xl mx-auto px-6 h-16 flex items-center gap-2">
          <BookHeart className="w-6 h-6 text-primary" />
          <span className="font-serif text-xl">Eterna</span>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-12 fade-in">
        <div className="mb-6">
          <h1 className="font-serif text-3xl tracking-tight">Comunicazione della scomparsa</h1>
          <p className="text-muted-foreground mt-2">Profilo di <strong>{data.owner_name}</strong>. Se ne hai titolo, comunica la scomparsa caricando il certificato di morte.</p>
        </div>
        <DeathProcess token={token} process={data.process} ownerName={data.owner_name} onUpdated={load} />
      </main>
    </div>
  );
};

export default ComunicaScomparsa;
